import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../utils/api';

// Thunk to fetch top categories
export const getSubcategoriesThunk = createAsyncThunk(
  'subcategories/getsubCategories',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.getSubcategory(id); 
      return response.data?.data?.data;
    } catch (error) {
        
      return rejectWithValue(
        error.response && error.response.data
          ? error.response.data.message
          : 'Failed to fetch top subcategory'
      );
    }
  }
);

// Slice for categories
const subCategorySlice = createSlice({
  name: 'subcategory',
  initialState: {
    subcategories: [],
    loading: false,
    error: null,
  },

  reducers: {
   
  },

  extraReducers: (builder) => {
    builder
      .addCase(getSubcategoriesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSubcategoriesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.subcategories = action.payload;
      })
      .addCase(getSubcategoriesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default subCategorySlice.reducer;

